(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jm-avaliacao-home"] && !Shopify.designMode) return;
  try {
    
  // Setas do carrossel de depoimentos.
  //
  // Rola um card por vez e desabilita a seta ao chegar na ponta: seta que nao
  // faz nada quando clicada passa a impressao de que a pagina travou.
  (function () {
    function ligar(secao) {
      if (secao.dataset.jmReviewsNav === 'on') return;
      var lista = secao.querySelector('.jm-reviews__list');
      var anterior = secao.querySelector('[data-jm-reviews-prev]');
      var proximo = secao.querySelector('[data-jm-reviews-next]');
      if (!lista || !anterior || !proximo) return;
      secao.dataset.jmReviewsNav = 'on';

      function passo() {
        var card = lista.querySelector('.jm-reviews__card');
        return card ? card.getBoundingClientRect().width + 14 : lista.clientWidth;
      }
      function atualizar() {
        var fim = lista.scrollWidth - lista.clientWidth - 2;
        anterior.disabled = lista.scrollLeft <= 2;
        proximo.disabled = lista.scrollLeft >= fim;
      }
      // Rola suave quando o navegador anima e, se nao sair do lugar, aplica
      // direto. Rolagem suave programatica nao acontece em aba de segundo
      // plano, em navegador embutido e para quem pediu menos movimento: sem
      // esta rede, a seta vira um botao morto justamente nesses casos.
      function rolar(distancia) {
        var partida = lista.scrollLeft;
        lista.scrollBy({ left: distancia, behavior: 'smooth' });
        setTimeout(function () {
          if (lista.scrollLeft === partida) {
            lista.scrollTo({ left: partida + distancia, behavior: 'instant' });
          }
        }, 320);
      }
      anterior.addEventListener('click', function () { rolar(-passo()); });
      proximo.addEventListener('click', function () { rolar(passo()); });
      lista.addEventListener('scroll', atualizar, { passive: true });
      window.addEventListener('resize', atualizar);
      atualizar();
    }

    function iniciar(raiz) {
      (raiz || document).querySelectorAll('.jm-reviews').forEach(ligar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciar(); });
    } else {
      iniciar();
    }
    // O editor de tema recria a secao a cada ajuste.
    document.addEventListener('shopify:section:load', function (evento) {
      if (evento.target && evento.target.querySelectorAll) iniciar(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
